import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import auth from '@/modules/authorization/store';
import commonStore from '@/shared/store';
import betsStore from '@/modules/bets/store';
import accountStore from '@/modules/account/store';
import fantasyCricketStore from '@/modules/cricket-fight/store';

const mutations = {
  resetState(state) {
    state.auth.user = null;
    state.auth.token = null;
    state.auth = {
      user: null,
      chips: null,
      token: null,
      eventManage: null,
      eventDetailHideSections: []
    };
    state.commonStore.siteVersion = null;
    state.commonStore.siteSettings = null;
  }
}
const actions = {
  resetAllState({ commit }) {
    commit('resetState')
  }
}

export default createStore({
  state: {},
  mutations,
  actions,
  modules: { 
    auth, 
    commonStore, 
    betsStore,
    accountStore,
    fantasyCricketStore 
    },
  plugins: [createPersistedState({
    key:'sd:site'
  })]
});